import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IWkMessageDialog } from './modal';

@Component({
  selector: 'wk-message-dialog',
  templateUrl: './message.dialog.html',
  styleUrls: ['./message.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WKMessageDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<WKMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IWkMessageDialog
  ) {}

  public close(result): void {
    this.dialogRef.close(result);
  }
}
